import { render } from "./BackNotice.vue?vue&type=template&id=19c5dc0f&scoped=true"
import script from "./BackNotice.vue?vue&type=script&lang=js"
export * from "./BackNotice.vue?vue&type=script&lang=js"

import "./BackNotice.vue?vue&type=style&index=0&id=19c5dc0f&lang=scss&scoped=true"
import "./BackNotice.vue?vue&type=style&index=1&id=19c5dc0f&lang=css"

import exportComponent from "D:\\pro\\edu-hsd\\cxcj\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c5dc0f"]])

export default __exports__